import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import imageBeer from '../../images/404.png';
import imageCoffee from '../../images/404-cappucino.png';
import classes from './NotFound.module.scss';
import { GeneralContext } from '../../context/generalContext';

export default function NotFound() {
  const { activeCity } = useContext(GeneralContext);

  let imageSrc = imageBeer;
  let imageCls = classes.imageBeer;
  let title = 'Упс! Страница не найдена,\nздесь только пиво';

  imageSrc = activeCity === 6 ? imageCoffee : imageBeer;
  imageCls = activeCity === 6 ? classes.imageCoffee : classes.imageBeer;
  title =
    activeCity === 6
      ? 'Упс! Страница не найдена,\nздесь только капучино'
      : 'Упс! Страница не найдена,\nздесь только пиво';

  return (
    <div className='wrapper wrapper-visible'>
      <Helmet>
        <title>404</title>
      </Helmet>
      <div className={classes.notFound}>
        <div className={imageCls}>
          <LazyLoadImage src={imageSrc} alt='page not found' className={classes.img} />
        </div>
        <div className={classes.textDiv}>
          <h1 className={classes.title}>{title}</h1>
          <p className={classes.text}>
            Страницы, которую вы искали, нет на нашем сайте. Возможно, вы ввели неправильный адрес или страница была
            удалена.
          </p>
          <Link to='/' className={classes.btn}>
            <p>Перейти на главную</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
